import { cn } from "@reactive-resume/utils";
import React, { forwardRef } from "react";

export const CardRoot = forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          "relative w-auto rounded-xl-admin border border-admin-border bg-admin-surface shadow-sm-admin",
          className,
        )}
      >
        {props.children}
      </div>
    );
  },
);
CardRoot.displayName = "CardRoot";

export const CardContent = forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn("flex w-full flex-row items-center justify-between gap-4 p-5", className)}
      >
        {props.children}
      </div>
    );
  },
);
CardContent.displayName = "CardContent";

export const TitleCard = forwardRef<
  HTMLDivElement,
  { classNameText?: string; classNameNumber?: string; text: string; number: string }
>(({ classNameNumber, classNameText, text, number }, ref) => {
  return (
    <div ref={ref} className="flex flex-col gap-1">
      <div className={cn("text-sm font-medium text-admin-text-muted", classNameText)}>{text}</div>
      <div className={cn("text-3xl font-bold text-admin-text-primary", classNameNumber)}>
        {number}
      </div>
    </div>
  );
});
TitleCard.displayName = "TitleCard";

export const ImageCard = forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => {
    return (
      <div ref={ref} className={cn("flex items-center justify-center", className)}>
        {props.children}
      </div>
    );
  },
);
ImageCard.displayName = "ImageCard";
